import React from 'react';
import {Box, Grid} from "@material-ui/core";
import CustomCenterDivider from "../../components/CustomCenterDivder/CustomCenterDivider";
import CustomCenterHeader from "../../components/CustomCenterHeader";
import StackCards from "../../components/StackCards";

const LandingChef = () => {
    return (
      <>
        <div style={{
          display: 'flex',
          alignItems: "center",
          justifyContent: "center",
          marginTop: 70,
          marginBottom: -100
        }}>
          <div style={{ width: '30%', height: 2, backgroundColor: '#ff8000', marginRight: 10 }} />
          <img src="/images/logo-orange.webp" title="Cuisine Crafters" height="100" />
          <div style={{ width: '30%', height: 2, backgroundColor: '#ff8000', marginLeft: 10 }} />
        </div>
        <div className="chef-page-container" style={{ backgroundColor: '#fff', minHeight: 400 }}>
          <div className="chef-page-content" style={{ paddingBottom: 80 }}>
            <h3>Chefs! Come onboard and book your next gig! </h3>
            <p>
              There is no shortage of private chef jobs out there. Our platform helps chefs and home cooks connect with clients to increase their business and income.
            </p>
          </div>
        </div>

        <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>
          <div className="chef-page-content chef-page-content-invert" style={{ paddingBottom: 80 }}>
            <h3>Create Your Profile and Share Your Voice </h3>
            <p>
              As a Chef or Home Cook, you can register on our site and create an online profile with your qualifications, specialty areas, and booking information. You can also write articles on the site to boost your authority and presence.
            </p>
          </div>
        </div>

        <div className="chef-page-container" style={{ backgroundColor: '#fff' }}>
          <div className="chef-page-content" style={{ paddingBottom: 80 }}>
            <h3>Build a Client Network</h3>
            <p>
              Over time, as a chef, you will be able to build out your client network and set up recurring weekly appointments with clients and build your standing on the platform to attract more clients. You can also take advantage of referrals as your network increases. Booking and delivering services through the platform increases your reputation over time, thereby gaining you more business.
            </p>
          </div>
        </div>

        <div style={{
            width: '100%',
            padding: '60px 10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Grid container direction="row" spacing={32}>
                <CustomCenterDivider />
                <CustomCenterHeader text="Get paid to be a <span style='color: #ff8000'>Chef</span> in <span style='color: #ff8000'>3</span> easy steps" computer={true} />
            </Grid>
            <Grid className="landing-container" container direction="row" spacing={32}>
                <Box className="landing-box">
                    <StackCards
                        image="/images/list.png"
                        txtHeader="List Your Profile"
                        txtSub={
                            <div className="landing-card-decription">
                              Build out your chef profile and add to your portfolio to showcase your skills and services.
                            </div>
                        }
                        title="Build a portfolio"
                        alt="Cuisine Crafters - Build Portfolio"
                        step="1"
                    />
                </Box>
                <Box className="landing-box">
                    <StackCards
                        image="/images/hired.png"
                        txtHeader="Get Hired"
                        txtSub={
                            <div className="landing-card-decription">
                              Clients can contact you directly through the platform and schedule bookings.
                            </div>
                        }
                        title="Get Hired"
                        alt="A diner likes your profile can hire you by booking an  appointment."
                        step="2"
                    />
                </Box>
                <Box className="landing-box">
                    <StackCards
                        image="/images/cook.png"
                        txtHeader="Deliver <span style='color: #ff8000; font-style: italic'>an</span> Experience"
                        txtSub={
                            <div className="landing-card-decription">
                              Deliver a memorable dining
                              experience to your clients.
                            </div>
                        }
                        title="Cook"
                        alt="Deliver memorable dining experience at diner's home."
                        step="3"
                    />
                </Box>
            </Grid>
        </div>
      </>
    );
};

export default LandingChef;
